// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"378":"user","680":"form","966":"dashboard"}[chunkId] + "." + {"378":"76a79b3d","680":"c1fd8902","966":"9aa0b800"}[chunkId] + ".js";
};